export function getUtmMetadataFromSearch(search, options = {}) {
  const params = new URLSearchParams(search || "");

  const maxKeys = Number.isFinite(options.maxKeys) ? options.maxKeys : 50;
  const maxKeyLength = Number.isFinite(options.maxKeyLength)
    ? options.maxKeyLength
    : 40;
  const maxValueLength = Number.isFinite(options.maxValueLength)
    ? options.maxValueLength
    : 500;

  /** @type {Record<string, string>} */
  const utm = {};

  for (const [rawKey, rawValue] of params.entries()) {
    const key = String(rawKey || "");
    if (!key) continue;
    if (!key.toLowerCase().startsWith("utm_")) continue;

    const value = rawValue == null ? "" : String(rawValue);
    if (!value) continue;

    const safeKey = key.slice(0, maxKeyLength);
    const safeValue = value.slice(0, maxValueLength);

    // Note: duplicates overwrite earlier values, which is fine for metadata.
    utm[safeKey] = safeValue;

    if (Object.keys(utm).length >= maxKeys) break;
  }

  return utm;
}


